import React, { useEffect } from "react";
import { openBankidApp, Device } from "./DeviceDetection";
import { BankIDLogo } from "./BankIDLogo";
import { PendingHintCode, FailedHintCode, Status, } from "./BankIdTypes";
import { QRCodeCanvas } from "qrcode.react";
import { Card } from "../cards/Card";
import "./BankID.scss";
import { Spinner } from "../spinner/Spinner";
import { Snackbar, SNACKBAR_TYPES } from "../snackbar/Snackbar";
import { Button } from "../buttons/Button";
import { Typography } from "../typography/Typography";
const QR_CODE_SIZE = 172;
export const BankIDStatus = ({ autoStartToken, response, isLysaApp = false, qrCode, setOpenOnOtherDevice, retry, reset, getMessages, getFailedMessages, getPendingMessages, }) => {
    const messages = getMessages();
    const isMobile = Device.isMobile();
    useEffect(() => {
        setOpenOnOtherDevice(!isMobile);
    }, [isMobile, setOpenOnOtherDevice]);
    if ((response === null || response === void 0 ? void 0 : response.status) === Status.FAILED) {
        let errorMessage = getFailedMessages(response.hintCode);
        if (!errorMessage) {
            console.error(`Unknown failed hint code ${response.hintCode}`);
            errorMessage = getFailedMessages(FailedHintCode.UNKNOWN);
        }
        return (React.createElement("div", { className: "lysa-ui-new-bankid" },
            React.createElement("div", { className: "top-alignment" },
                React.createElement(BankIDLogo, { size: 80 })),
            React.createElement("div", { className: "bottom-alignment" },
                React.createElement(Snackbar, { icon: true, type: SNACKBAR_TYPES.ERROR },
                    React.createElement("div", null,
                        React.createElement(Typography, { type: "h5", component: "h2" }, messages.buttonErrorHeader),
                        errorMessage)),
                React.createElement("div", { className: "button-container" },
                    React.createElement(Button, { block: true, variant: "primary", onClick: retry, label: messages.buttonRetry }),
                    reset && (React.createElement(Button, { block: true, variant: "outlined", onClick: reset, label: messages.buttonClose }))))));
    }
    const openedOrderInBankIdApp = (response === null || response === void 0 ? void 0 : response.hintCode) === PendingHintCode.STARTED ||
        (response === null || response === void 0 ? void 0 : response.hintCode) === PendingHintCode.USERSIGN;
    const mobilePending = isMobile && !qrCode;
    const isPending = mobilePending || !response || openedOrderInBankIdApp;
    let pendingMessage = null;
    if (response === null || response === void 0 ? void 0 : response.hintCode) {
        pendingMessage = getPendingMessages(response.hintCode);
        if (!pendingMessage) {
            console.error(`Unknown pending hint code ${response.hintCode}`);
            pendingMessage = getPendingMessages(PendingHintCode.OUTSTANDINGTRANSACTION);
        }
    }
    return (React.createElement("div", { className: "lysa-ui-new-bankid" },
        React.createElement("div", { className: "top-alignment" },
            React.createElement("p", { className: "pending-message-container" }, pendingMessage)),
        React.createElement("div", { className: "bottom-alignment" }, autoStartToken && (React.createElement(React.Fragment, null,
            isPending ? (React.createElement(Spinner, null)) : (React.createElement("div", { className: "qr-container" },
                React.createElement(Card, { style: { marginBottom: 0 } },
                    React.createElement("div", { className: "qr-code-wrapper" }, qrCode ? (React.createElement(QRCodeCanvas, { size: QR_CODE_SIZE, includeMargin: true, value: qrCode })) : (React.createElement("div", { style: {
                            width: `${QR_CODE_SIZE}px`,
                            height: `${QR_CODE_SIZE}px`,
                            padding: "60px",
                        } },
                        React.createElement(Spinner, null))))),
                React.createElement("ol", { className: "qr-code-instructions" },
                    React.createElement("li", null, messages.qrInfo1),
                    React.createElement("li", null, messages.qrInfo2),
                    React.createElement("li", null, messages.qrInfo3)))),
            React.createElement("div", { className: "button-container" },
                React.createElement(Button, { block: true, variant: mobilePending ? "primary" : "secondary", onClick: () => openBankidApp(autoStartToken, isLysaApp), label: messages.buttonOpen }),
                mobilePending && (React.createElement(Button, { block: true, variant: "secondary", onClick: () => setOpenOnOtherDevice(true), label: messages.buttonOtherDevice })),
                reset && (React.createElement(Button, { block: true, variant: "outlined", onClick: reset, label: messages.buttonClose }))))))));
};
